

function pdfBuilder(options) {
  this.options = options;
} 

pdfBuilder.prototype.exportSketches = function () {
  var vects = [];
  var url = "/wp-content/themes/frontier-child/models/pao-model-sketches.php?parid=" + this.options.parid;
  return new Promise(function (resolve, reject) {
    getSketches(url).then(function (result) {
      resolve(result);
    })["catch"](function (error) {
      console.log(error);
      reject(error);
    });
  });

  function getSketchData(url) {
    return $.ajax({
      url: url,
      method: "GET",
      contentType: "application/json"
    });
  } 

  function getSketches(url) {
    return new Promise(function (resolve, reject) {
      getSketchData(url).then(handleSketchData)["catch"](function (error) {
        console.log(error);
        reject(error);
      });
    }); 
  } 

  function handleSketchData(result_data) {
    $.each(JSON.parse(result_data), function (idx, data) {
      if (idx === 'rows') {
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            $.when(getSketchGeometry(data[i].VECT)).then(function (resolve, reject) {
              saveSkechData(resolve)["catch"](function (error) {
                console.log(error);
                reject(error);
              });
            });
          } 
        } 
      } 
    });
  } 

  function getSketchGeometry(vect) {
    return $.ajax({
      url: "/sketch.server/sketchHandler1.ashx?gridunits=0&usecolors=true&width=450&height=450&vector=" + vect,
      method: "GET",
      contentType: "image/png",
      success: function success(response, statusText) {
      },
      error: function error(response, statusText) {
      }
    });
  } 

  function saveSkechData(data) {
    vects.push(data);
  } 

};

pdfBuilder.prototype.exportPdf = function () {
  var parid = this.options.parid;
  var isTppParcel = this.options.isTppParcel;
  var isLeasingCompany = this.options.isLeasingCompany;
  var windowHandle = this.options.windowHandle;
  var obj = {
    parid: parid,
    map_image_path: this.options.map_image_path,
    isTppParcel: isTppParcel,
    isLeasingCompany: isLeasingCompany
  };
  var data = JSON.stringify(obj); 

  return new Promise(function (resolve, reject) {
    $.ajax({
      url: paoDetails.context.child_uri + "/models/pao-pdfw.php",
      type: "POST",
      data: {
        'params': data,
        'report': 'prc'
      },
      dataType: "text"
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var err = textStatus + ", " + errorThrown;
      console.log("Request Failed: " + err);
      reject(err);
    }).done(function (result) {
      if (result && result.length) {
        windowHandle.location.href = paoDetails.context.href + "/prc";
        resolve(true);
      }
    });
  });
}; 


function exportMapService(options) {
  this.options = options;
  this.options.latestYearAerial = paoDetails.gis.services.latestYearAerial.url;
  this.options.mapLayerAndLabelsUrl = paoDetails.gis.services.mapLayerAndLabels.url;
  this.options.printServiceUrl = paoDetails.gis.services.printService.url;
  return true;
}

function prc_promiseRejected(error) {
  console.log("Promise rejected: ", error);
}



exportMapService.prototype.exportEsriMap2Image = function () {
  var parid = this.options.parid;
  var child_uri = this.options.child_uri;
  var latestYearAerial = this.options.latestYearAerial;
  var mapLayerAndLabelsUrl = this.options.mapLayerAndLabelsUrl;
  var printServiceUrl = this.options.printServiceUrl;
  var isLeasingCompany = this.options.isLeasingCompany;
  return new Promise(function (resolve) {
    if (isLeasingCompany) {
      var url = child_uri + "/images/no-aerial-data.png";
      var response = {
        data: {
          results: [{
            value: {
              url: url
            }
          }]
        }
      };
      resolve(response);
      return;
    }

    require(["esri/rest/support/Query", "esri/layers/FeatureLayer",
      "esri/request", "esri/geometry/Extent"],
      function (Query, FeatureLayer, esriRequest, Extent) {
        var query = new Query({
          returnGeometry: true,
          returnExtentOnly: true,
          outSpatialReference: {
            wkid: 4326
          },
          outFields: [paoDetails.gis.queryFields],
          orderByFields: ["PARID"]
        });
        query.where = "PARID='" + parid + "'";
        var layer = new FeatureLayer({
          url: mapLayerAndLabelsUrl + "/" + paoDetails.gis.services.mapLayerAndLabels.indices.parcelSearch
        });
        layer.queryFeatures(query).then(function (results) {
          if (results.features && !results.features.length > 0) {
            resolve(results.features); 
          } else {
            var xmin = "",
              ymin = "",
              xmax = "",
              ymax = "",
              wkid = "",
              urlA = ""; 

            if (results.features && results.features[0]) {
              xmin = results.features[0].geometry.extent.xmin;
              ymin = results.features[0].geometry.extent.ymin;
              xmax = results.features[0].geometry.extent.xmax;
              ymax = results.features[0].geometry.extent.ymax; 

              var extent = new Extent({
                "xmin": xmin,
                "ymin": ymin,
                "xmax": xmax,
                "ymax": ymax
              });
              extent.expand(1.5);
              xmin = extent.xmin;
              ymin = extent.ymin;
              xmax = extent.xmax;
              ymax = extent.ymax;
            } else {
            }

            wkid = results.spatialReference.wkid; 

            urlA = printServiceUrl + "/execute?";
            var symbol = {
              "type": "simple",
              "symbol": {
                "type": "esriSFS",
                "style": "esriSFSNull",
                "outline": {
                  "type": "esriSLS",
                  "style": "esriSLSSolid",
                  "color": [66, 244, 206],
                  "width": 3
                }
              }
            }; 

            var drawingInfo = {
              "renderer": symbol
            }; 

            var webParcelLinesLayers = {
              "opacity": 1,
              "minScale": 0,
              "maxScale": 0,
              "url": mapLayerAndLabelsUrl
            }; 

            var webParcelLinesLayers3 = {
              "opacity": 1,
              "minScale": 0,
              "maxScale": 0,
              "url": mapLayerAndLabelsUrl,
              "layers": [{
                "id": paoDetails.gis.services.mapLayerAndLabels.indices.parcelLines,
                "layerDefinition": {
                  "drawingInfo": drawingInfo,
                  "source": {
                    "type": "mapLayer",
                    "mapLayerId": paoDetails.gis.services.mapLayerAndLabels.indices.parcelLines
                  },
                  "definitionExpression": "PARID='" + parid + "'"
                }
              }]
            };
            var operationalLayers = [{
              "opacity": 1,
              "minScale": 0,
              "maxScale": 0,
              "url": latestYearAerial
            }]; 

            operationalLayers.push(webParcelLinesLayers); 

            operationalLayers.push(webParcelLinesLayers3);
            var json = {
              "mapOptions": {
                "showAttribution": false,
                "extent": {
                  "xmin": xmin,
                  "ymin": ymin,
                  "xmax": xmax,
                  "ymax": ymax,
                  "spatialReference": {
                    "wkid": wkid 
                  }
                },
                "spatialReference": {
                  "wkid": wkid 
                },
                "rotation": 0
              },
              "operationalLayers": operationalLayers,
              "exportOptions": {
                "outputSize": [400, 400],
                "dpi": 96 
              }
            }; 

            var Web_Map_as_JSON = JSON.stringify(json);

            url = urlA;
            var options = {
              method: 'POST',
              query: {
                Web_Map_as_JSON: Web_Map_as_JSON,
                Format: "PNG8",
                Layout_Template: "MAP_ONLY",
                f: "json"
              }
            };
            esriRequest(url, options).then(function (response) {
              resolve(response);
              return true;
            })["catch"](function (response) {
              prc_promiseRejected(response);
              var url = child_uri + "/images/no-aerial-data.png"; 

              var response_url = {
                data: {
                  results: [{
                    value: {
                      url: url
                    }
                  }]
                }
              };
              resolve(response_url);
            }); 
          } 
        }); 
      }); 
  }); 
}; 